import { isRecord } from "@/utils/is-record";

function splitPath(path: string): string[] {
    return path.split(".").filter(Boolean);
}

function cloneObjectOrEmpty(value: unknown): Record<string, unknown> {
    return isRecord(value) ? { ...value } : {};
}

export function getAtPath(source: unknown, path: string): unknown {
    const parts = splitPath(path);
    let cursor = source;

    for (const part of parts) {
        if (!isRecord(cursor)) {
            return undefined;
        }
        cursor = cursor[part];
    }

    return cursor;
}

export function setAtPathImmutable(source: unknown, path: string, value: unknown): unknown {
    const parts = splitPath(path);
    if (parts.length === 0) {
        return value;
    }

    const root = cloneObjectOrEmpty(source);
    let cursor = root;

    for (let index = 0; index < parts.length; index += 1) {
        const part = parts[index];
        if (index === parts.length - 1) {
            cursor[part] = value;
            break;
        }

        const child = cloneObjectOrEmpty(cursor[part]);
        cursor[part] = child;
        cursor = child;
    }

    return root;
}
